<div class="login-page">

    <ng-container *ngIf="!id">
        <div class="ovn-loading" *ngIf="loading$ | async">
            <mat-spinner diameter="36"></mat-spinner>
        </div>
    </ng-container>

    <ng-container *ngIf="id">
        <div class="promo-block">
<!--            <img class="promo-image" src="../assets/icons/auth/promo_image.svg" alt="">-->
            <div class="promo-block-content">
                <div class="content-header">{{ 'logIn.promoBlock.contentHeader' | translate }}</div>
                <div class="content-description">{{ 'logIn.promoBlock.contentDescription' | translate }}</div>
                <div class="content-items">
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem1' | translate }}</span>
                    </div>
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem2' | translate }}</span>
                    </div>
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem3' | translate }}</span>
                    </div>
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem4' | translate }}</span>
                    </div>
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem5' | translate }}</span>
                    </div>
                    <div class="content-item">
                        <canvas></canvas>
                        <span>{{ 'logIn.promoBlock.contentItem6' | translate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-block">
            <div class="login-header">
                {{ 'logIn.title' | translate }}
            </div>

            <form [formGroup]="loginForm" class="login-form gap30">
                <mat-form-field appearance="outline" class="mdc-field-medium full-width" floatLabel="always">
                    <mat-label>{{ 'logIn.form.formLabels.login' | translate | titlecase }}</mat-label>
                    <input (keydown.enter)="submitForm()" [required]="true" autocomplete="off" formControlName="login" matInput type="text">
                </mat-form-field>

                <mat-form-field appearance="outline" class="mdc-field-medium full-width" floatLabel="always">
                    <mat-label>{{ 'logIn.form.formLabels.password' | translate | titlecase }}</mat-label>
                    <div class="df ai-c gap10">
                        <input (keydown.enter)="submitForm()" [required]="true" [type]="hidePass ? 'password' : 'text'" formControlName="password" matInput>
                        <button (click)="hidePass = !hidePass" *ngIf="loginForm.get('password')?.value"
                                [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hidePass" class="pass-hider">
                            <mat-icon class="default-icon">{{ hidePass ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </div>
                </mat-form-field>
            </form>

            <div class="buttons-row login-buttons full-width">
                <button (click)="submitForm()" [disabled]="loginForm.invalid || (loading$ | async) === true" class="btn primary spinner-button">
                    <span *ngIf="(loading$ | async) === false">{{ 'logIn.buttons.signIn' | translate | titlecase }}</span>
                    <mat-spinner *ngIf="(loading$ | async) === true" diameter="30"></mat-spinner>
                </button>
            </div>
        </div>
    </ng-container>

</div>
